import React, { useEffect, useState } from "react";
import { Profile, Toast } from "../../Components";

import CreateReview from "../CreateReview/CreateReview";

import { useNavigate } from "react-router-dom";
import { offerService, reviewService } from "../../Services";
import ShowOfferDetails from "../CreateReview/ShowOfferDetails";

export default function Review(props) {
  const [isloaded, setIsLoaded] = useState(false);
  const [isOfferDetailsloaded, setIsOfferDetailsloaded] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [offerId, setOfferId] = useState(props.offerSelectedForReview);
  const [readOnly, setReadOnly] = useState(false);
  const [review, setReview] = useState(null);
  const [offerDetails, setOfferDetails] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    //setUserHasSubscription(user ? user.data.isUserHasSubscription == 1 ? true : false : false)
    async function fetchDataForOfferReview() {
      try {
        const res = await reviewService.getReviewByOfferId(offerId);
        setIsLoaded(true);
        if (res.success == true) {
          if (res.data != null) {
            setReadOnly(true);
          } else {
            setReadOnly(false);
          }
          setReview(res.data);
        }
      } catch (err) {
        if (err.apiResponseStatus != 404) {
          addToast({
            error: true,
            msg: err.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsLoaded(true);
        }
      }
    }
    async function fetchOfferDetails() {
      try {
        const res = await offerService.getOfferDetailsByOfferId(offerId);
        if (res.data != null && res.success == true) {
          setOfferDetails(res.data);
          setIsOfferDetailsloaded(true);
        }
      } catch (err) {
        if (err.apiResponseStatus != 404) {
          addToast({
            error: true,
            msg: err.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsOfferDetailsloaded(true);
        }
      }
    }
    if (offerId == null) {
      gotoOffer();
    } else {
      fetchDataForOfferReview();
      fetchOfferDetails();
    }
  }, []);
  const gotoOffer = () => {
    navigate("/influencer/offers");
  };
  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  return (
    <>
      <div className="main">
        <div className="main__inner">
          <div className="main__inner-title">
            {/* <h2>Review</h2> */}
            {/* <Profile
              user={props.user}
              setModal={props.setModal}
              profiles={props.profiles}
              NotifModul={props.NotifModul}
              setNotifModul={props.setModalNotification}
            /> */}
          </div>
          {isOfferDetailsloaded && (
            <ShowOfferDetails
              user={props.user.data}
              offerDetails={offerDetails}
              gotoOffer={gotoOffer}
              readOnly={readOnly}
              toastList={toastList}
              setToastList={setToastList}
              offerId={offerId}
            />
          )}
          {isloaded && (
            <CreateReview
              isloaded={isloaded}
              user={props.user.data}
              offerDetails={offerDetails}
              gotoOffer={gotoOffer}
              readOnly={readOnly}
              review={review}
              toastList={toastList}
              setToastList={setToastList}
              offerId={offerId}
            />
          )}{" "}
        </div>
      </div>
      {toastList && <Toast list={toastList} setList={setToastList} />}
    </>
  );
}
